import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NestedUtils from './../multistep-select/NestedUtils';

class DisabledSelectedListNested extends Component {

    constructor(props)
    {
        super(props);
    }

    generateItemName(item) {
        const data = this.props.nestedUtils.orderFromParentsToChildren(item.id);

        const names = data.map(item => item.name);

        return names.join(' \u2023 ');
    }

    render() {
        const items = this.props.nestedUtils
            .findByIds(this.props.selection);

        const list = items.map(item => {
            return (
                <span key={item.id} className='Select has-value is-disabled is-searchable Select--multi'>
                    <div className="Select-value">
                        <span className="Select-value-label"
                              role="option" aria-selected="true"
                              id="react-select-3--value-1">
                            {this.generateItemName(item)}
                            <span className="Select-aria-only">&nbsp;</span>
                        </span>
                    </div>
                </span>
            )
        });

        if (items.length) {
            return (
                <div className="Select--multi">
                    {list}
                </div>
            );
        } else {
            return null;
        }
    }
}
DisabledSelectedListNested.propTypes = {
    nestedUtils: PropTypes.instanceOf(NestedUtils).isRequired,
    selection: PropTypes.array.isRequired,
    deleteButtonText: PropTypes.string,
};

export default DisabledSelectedListNested;


// WEBPACK FOOTER //
// ./web/src/components/multistep-select/DisabledSelectedListNested.jsx